import logo from '@/assets/images/logo/logo_img.png'

let platformConfig = {}
// 測試環境
const beforeOnlineConfig = {
  logo,
  appId: 'dev-id',
  locale: {
    // tw: '繁體中文',
    en: 'English'
  },
  title: 'Goldten Forex Dashboard',
  baseURL: 'https://dev.goldten.vip/gateway/admin',
  // uploadUrl: 'https://dev.coinfare.net/gateway/common/upload/file',
  // forgetPasswordUrl: 'https://dev.coinfare.net/gateway/common/user/forgetPassword',
  // phoneCountryUrl: 'https://dev.coinfare.net/gateway/common/query/country',
  // userCountryUrl: 'https://dev.coinfare.net/gateway/common/query/country/type'
}
// 正式環境
const coinfareConfig = {
  logo,
  appId: 'dev-id',
  locale: {
    // tw: '繁體中文',
    en: 'English'
  },
  title: 'Goldten Forex Dashboard',
  baseURL: 'https://dev.coinfare.net/gateway/admin',
  // uploadUrl: 'https://dev.coinfare.net/gateway/common/upload/file',
  // forgetPasswordUrl: 'https://dev.coinfare.net/gateway/common/user/forgetPassword',
  // phoneCountryUrl: 'https://dev.coinfare.net/gateway/common/query/country',
  // userCountryUrl: 'https://dev.coinfare.net/gateway/common/query/country/type'
}
switch (process.env.VUE_APP_TITLE) {
  case 'fiatExchange': // 正式
    platformConfig = coinfareConfig
    break
  case 'beforeOnline': // 測試
    platformConfig = beforeOnlineConfig
    break
  default:
    platformConfig = beforeOnlineConfig
}
export default platformConfig
